// V4/V5 企业看板共享色板（JS 计算用）。
// 结构样式见同目录 dashboard.css（.aiq-dash 作用域）；这里只放需要按数据动态计算的颜色。

// （LEVEL_COLOR 已随风险板块去档位/去颜色分级移除——风险预警不再按等级配色。）

// 热力图分数 → 单元格背景色（配白字）。
// 全部压暗到白字对比 ≥3:1（旧版 60-69 用 #facc15 黄底白字几乎不可读，本次修复）。
export function heatColor(score) {
  if (score >= 80) return '#15803d'; // 绿
  if (score >= 70) return '#4d8a2e'; // 黄绿
  if (score >= 60) return '#a16207'; // 琥珀
  if (score >= 50) return '#c2620a'; // 橙
  if (score >= 40) return '#c2410c'; // 橙红
  return '#991b1b';                  // 红
}

// 总分分布柱 → 扁平配色（浅色底 + 同色描边，无玻璃高光）。
export function scoreBucketTone(label = '') {
  const start = Number(String(label).split('-')[0]);
  if (Number.isNaN(start)) return { fill: '#e9f0ff', stroke: '#1f53e6' };
  if (start >= 90) return { fill: '#e7f5ec', stroke: '#15803d' };
  if (start >= 70) return { fill: '#e9f0ff', stroke: '#1f53e6' };
  if (start >= 60) return { fill: '#e3f3f1', stroke: '#0f766e' };
  if (start >= 40) return { fill: '#fbf1e3', stroke: '#b45309' };
  return { fill: '#fbeaea', stroke: '#b91c1c' };
}
